import { render, staticRenderFns } from "./link-opt-in-form.vue?vue&type=template&id=1db7b926&scoped=true&"
import script from "./link-opt-in-form.vue?vue&type=script&lang=js&"
export * from "./link-opt-in-form.vue?vue&type=script&lang=js&"
import style0 from "./link-opt-in-form.vue?vue&type=style&index=0&id=1db7b926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7b926",
  null
  
)

export default component.exports